import { QUERY_PARAM_DEVICE, QUERY_PARAM_TARIFF, QUERY_PARAM_YOUNG } from '../constant';
import { SalesChannel } from '../enum';
import getPageOptions, { isFlexId } from './additionalPageOptionsHelper';

const isFlexUrl = () => {
    return location.pathname === getPageOptions()?.contentUrls.flex;
};

const getQueryString = (subId: string, hardwareId: string, sales: SalesChannel) => {
    const searchParams = new URLSearchParams(location.search);

    searchParams.set(QUERY_PARAM_TARIFF, subId);
    searchParams.set(QUERY_PARAM_DEVICE, hardwareId);

    sales === SalesChannel.YOUNG
        ? searchParams.set(QUERY_PARAM_YOUNG, 'true')
        : searchParams.delete(QUERY_PARAM_YOUNG);

    return searchParams.toString();
};

export const getPathData = (subId?: string, hardwareId?: string, sales?: SalesChannel) => {
    const contentUrls = getPageOptions()?.contentUrls;

    if (!contentUrls || !subId || !hardwareId || !sales) {
        return undefined;
    }

    const query = getQueryString(subId, hardwareId, sales);
    const switchToFlex = isFlexId(subId) && !isFlexUrl();
    const switchToConsumer = !isFlexId(subId) && isFlexUrl();

    if (switchToFlex) {
        return { path: `${contentUrls.flex}?${query}`, force: true };
    }

    if (switchToConsumer) {
        return { path: `${contentUrls.consumer}?${query}`, force: true };
    }

    return { path: `${location.pathname}?${query}`, force: false };
};
